import type { ReactNode } from 'react';
import { AuthPage } from '@zagru/design-system';
import { useShellT } from '@/app/shell/i18n';
import { Wordmark } from '@/app/brand/Wordmark';

export interface AuthFrameProps {
  title: ReactNode;
  description?: ReactNode;
  actions?: ReactNode;
  children?: ReactNode;
  /** OIDC/technical code, available behind a disclosure. */
  technical?: string;
  footer?: ReactNode;
}

/**
 * The frame every pre-session screen uses (sign-in interstitial, callback failure, signed out): the design
 * system's AuthPage archetype with the product wordmark, so leaving the app for the identity provider and
 * coming back never feels like leaving the product.
 */
export function AuthFrame({ title, description, actions, children, technical, footer }: AuthFrameProps) {
  const t = useShellT();
  return (
    <AuthPage
      brand={<Wordmark tone="onDark" size="lg" />}
      mobileBrand={<Wordmark size="md" />}
      tagline={t('shell.brand.tagline')}
      claim={t('auth.frame.claim')}
      legal="© Zagru"
      technicalLabel={t('failure.technicalDetails')}
      title={title}
      description={description}
      actions={actions}
      technical={technical}
      footer={footer}
    >
      {children}
    </AuthPage>
  );
}
